import React from 'react'
import Banner from '../components/Banner'
import Hero from '../components/Hero'
import Services from '../components/Services'
import { FaYoutube, FaCameraRetro, FaInfoCircle, FaCode, FaFacebook } from 'react-icons/fa';

export default function Main() {
    return (
        <>
            <Hero>
                <Banner title="Alkornithm" subtitle="Programming Journal" />
            </Hero>
            <Services title="Services" services={[{
                icon: <FaCode />,
                title: "Grader",
                info: 'This is an online judge that can be used for conducting or competitive programming.',
            },
            {
                icon: <FaYoutube color="red" />,
                title: "Free YouTube programming courses",
                info: 'Alkornithm channel include free programming playlists such as algorithm, project management, etc.',
            },
            {
                icon: <FaCameraRetro color="black" />,
                title: "Writer Life",
                info: 'Id do excepteur et ad ipsum sint nisi amet et duis mollit veniam sint.',
            },
            {
                icon: <FaInfoCircle color="blue" />,
                title: "Programming tips",
                info: 'Id do excepteur et ad ipsum sint nisi amet et duis mollit veniam sint.',
            }]} />

            <Services title="Social media" services={[{
                icon: <FaFacebook color='blue' />,
                title: "Facecbook",
                info: 'This is an online judge that can be used for conducting or competitive programming.',
            }]} />

        </>
    )
}